<template>
  <main>
    <div class="row">
      <div class="col-md-12">
        <TopTemplate>
          <template v-slot:left-element>
            <h3>{{ $t("title.listPayment") }} ({{ total }})</h3>
          </template>

          <!--  <template v-slot:right-element>
                <router-link
                  :to="{ name: 'AddPayment' }"

                  class="btn button btn-primary"
                  :disabled="loading"
                >
                  <i class="icon-Add"></i>
                  Ajouter paiement
                </router-link>
              </template> -->
        </TopTemplate>
        <div class="search-date-wrapper search-filter-wrapper" :class="showFil === false ? 'borderNan' : ''">
          <div class="col-md-12 search searchTeacher">
            <input v-model="params.q" type="text" placeholder="Recherche" name="search" @input="searshParent()" />
            <img src="../../assets/icons/search-icon.svg" class="icon-search" alt="search" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
      <div class="spinner-border text-info" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-if="!loading">
      <div class="row gx-2 solde-row">
        <div class="col-md-4 margin-div">
          <div class="default-border">
            <div class="icon-mony">
              <div class="image-mony image-mony--image1">
                <img src="../../assets/icons/Money.svg" />
              </div>
              <h3>{{ totalSold }}Dt</h3>
            </div>
            <span class="mt-y">{{ $t("title.TotalSold") }}</span>
          </div>
        </div>
        <div class="col-md-4 margin-div">
          <div class="default-border">
            <div class="icon-mony">
              <div class="image-mony image-mony--image2">
                <img src="../../assets/icons/Vector.svg" />
              </div>
              <h3>+{{ PositiveSold }}Dt</h3>
            </div>
            <span class="mt-1">{{ $t("title.PositifSold") }}</span>
          </div>
        </div>
        <div class="col-md-4 margin-div">
          <div>
            <div class="icon-mony">
              <div class="image-mony image-mony--image3">
                <img src="../../assets/icons/Vector-1.svg" />
              </div>
              <h3>{{ NegativSold }}Dt</h3>
            </div>
            <span class="ml-25 mt-1">{{ $t("title.negatifSold") }}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-5 col-xl-4  ms-auto mt-2">
          <div class="filter filter-paiement">
            <v-select
              v-model="filterSolde"
              @update:modelValue="changeSold($event)"
              auto
              placeholder="Filtrer par"
              :searchable="false"
              :options="soldTypes"
              label="name"
              :reduce="(option) => option.id"
              class="form-control"
            >
            </v-select>
          </div>
        </div>
      </div>
    </div>
    <div class="empty-message">
      <div class="col-md-12">
        <div v-if="!loading && payements.length == 0" class="card mt-4">
          <div class="col-12 empty-result text-center pt-3">
            <p>{{ $t("common.emptysearshPayment") }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loading && payements.length > 0">
      <div class="table message-list custom-table">
        <div class>
          <div class="row">
            <div class="col-md-12">
              <div class="table__wrapper">
                <table>
                  <thead>
                    <tr>
                      <th class="col-md-5">
                        {{ $t("paiement.tab.name") }}
                        <div class="icon-wrapper" @click="sortB('student.first_name')">
                          <i class="ri-arrow-up-s-line" :class="[specTri('student.first_name', true)]" />
                          <i class="ri-arrow-down-s-line" :class="[specTri('student.first_name', false)]" />
                        </div>
                      </th>
                      <th class="col-md-4">
                        {{ $t("paiement.tab.solde") }} (DT)
                        <div class="icon-wrapper" @click="sortB('solde')">
                          <i class="ri-arrow-up-s-line" :class="[specTri('solde', true)]" />
                          <i class="ri-arrow-down-s-line" :class="[specTri('solde', false)]" />
                        </div>
                      </th>
                      <th class="col-md-4 text-center">{{ $t("common.actions") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="payement in payements" :key="payement.id">
                      <td class="col-md-5">{{ payement.first_name }} {{ payement.last_name }}</td>

                      <td class="col-md-4">
                        <span v-if="payement.solde > 0" style="color: #377879">+{{ payement.solde.toFixed(3) }}</span>
                        <span v-if="!payement.solde || payement.solde === 0" style="margin-left: 20px">__</span>
                        <span v-if="payement.solde < 0" style="color: #f35b19">{{ payement.solde.toFixed(3) }}</span>
                      </td>
                      <td class="col-md-4 text-center">
                        <div>
                          <router-link
                            :to="{
                              name: 'DetailsPayment',
                              params: {id: payement.id},
                            }"
                            class
                          >
                            <i class="icon-eyes icon-eyes-v1">
                              <span class="tooltiptext">{{ $t("button.tooltip.details") }}</span>
                            </i>
                          </router-link>
                          <i
                            @click.prevent="envoiFacture(payement.id, payement.solde)"
                            :class="!payement.solde || payement.solde > 0 ? 'not-exist' : 'exist'"
                            class="icon-send-msg"
                          >
                            <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M1.25 7.5C1.25 5.14298 1.25 3.96447 1.98223 3.23223C2.71447 2.5 3.89298 2.5 6.25 2.5H8.75C11.107 2.5 12.2855 2.5 13.0178 3.23223C13.75 3.96447 13.75 5.14298 13.75 7.5C13.75 9.85702 13.75 11.0355 13.0178 11.7678C12.2855 12.5 11.107 12.5 8.75 12.5H6.25C3.89298 12.5 2.71447 12.5 1.98223 11.7678C1.25 11.0355 1.25 9.85702 1.25 7.5Z"
                                :stroke="payement.solde > 0 ? '#a8aaad' : '#1C274C'"
                                stroke-width="1.5"
                              />
                              <path
                                d="M3.75 5L5.09931 6.12443C6.24721 7.08101 6.82116 7.5593 7.5 7.5593C8.17884 7.5593 8.75279 7.08101 9.90069 6.12442L11.25 5"
                                :stroke="payement.solde > 0 ? '#a8aaad' : '#1C274C'"
                                stroke-width="1.5"
                                stroke-linecap="round"
                              />
                            </svg>
                            <span v-if="payement.solde > 0" class="tooltiptext">{{ $t("button.tooltip.send") }}</span>
                          </i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="table__wrapper__pagination-wrapper">
                  <div class="pagination">
                    <pagination v-if="last_page > 1" :dataSet="pagination" @goToPage="getResults" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import PaymentService from "../../services/payment.service";

import pagination from "../../components/navigation/Pagination";
import moment from "moment";
import _ from "lodash";
import vSelect from "vue-select";
export default {
  name: "PaymentList",
  components: {
    TopTemplate,
    pagination,
    "v-select": vSelect,
  },
  data() {
    return {
      pagination: {},
      total: 0,
      last_page: null,
      loading: false,
      showFil: false,
      params: {
        q: "",
        s: "cmp",
        limit: 15,
        page: 1,
        sort: "created_at",
        order: false,
      },
      payements: [],
      nameParent: null,
      filterSolde: null,
      NegativSold: null,
      PositiveSold: null,
      totalSold: null,
      soldTypes: [
        {
          name: "Solde total",
          id: 2,
        },
        {
          name: "Total de compte négatif",
          id: "debit",
        },
        {
          name: "Total de compte positif",
          id: "credit",
        },
      ],
    };
  },
  mounted() {
    this.ListPayments();
  },
  methods: {
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
      this.ListPayment();
    },
    // sortB: _.debounce(function() {
    //   this.params.order = this.params.order === "desc" ? "asc" : "desc";
    //   this.ListPayments();
    // }, 200),
    specTri(param, order) {
      if (this.params.order === null && this.params.sort === "") {
        return "";
      } else {
        if (this.params.sort === param) {
          if (this.params.order === order) {
            return "ordredA";
          } else {
            return "ordredD";
          }
        } else {
          return "";
        }
      }
    },
    sortB: _.debounce(function (param) {
      this.params.order = this.params.order === false ? true : false;
      this.params.sort = param;
      this.ListPayments();
    }, 200),
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
      this.ListPayments();
    },
    envoiFacture(id, solde) {
      if (solde < 0) {
        const Swal = require("sweetalert2");
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-confirm  btn-primary",
            cancelButton: "btn  btn-cancel  btn-outline-primary",
          },
          buttonsStyling: false,
          showCloseButton: true,
        });
        const index = this.payements.findIndex((items) => items.id === id);
        swalWithBootstrapButtons
          .fire({
            title: this.$t("common.confirmSendMessage"),
            icon: "warning",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: this.$t("common.envoiIT"),
            cancelButtonText: this.$t("common.noCancel"),
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              swalWithBootstrapButtons.fire(this.$t("common.messageSend"), "", "success");

              PaymentService.facture(id);
            }
          });
      }
    },
    ListPayments() {
      this.loading = true;
      PaymentService.getAll({
        params: {
          q: this.params.q,
          s: this.params.s,
          limit: this.params.limit,
          page: this.params.page,
          sort: this.params.sort,
          order: this.params.order,
          sold: this.filterSolde == 2 ? null : this.filterSolde,
        },
      })
        .then((response) => {
          this.payements = response.data.data;
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.total = response.data.meta.total;
          this.last_page = response.data.meta.last_page;
          this.loading = false;
          this.NegativSold = response.data.negative_sold;
          this.PositiveSold = response.data.positive_sold;
          this.totalSold = response.data.total;
        })
        .catch((error) => {
          if (error.response && error.response.status === 403) {
            this.$router.push("/error-403");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },
    changeSold(event) {
      this.ListPayments();
    },
    getResults(page = null) {
      this.params.page = !page ? this.params.page : page;
      this.loading = true;

      PaymentService.getAll({
        params: {
          limit: this.params.limit,
          page: this.params.page,
          q: this.params.q,
          s: this.params.s,
          sort: this.params.sort,
          order: this.params.order,
          sold: this.filterSolde == 2 ? null : this.filterSolde,
        },
      }).then(
        (response) => {
          this.payements = response.data.data;

          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.total = response.data.meta.total;
          this.loading = false;
          this.NegativSold = response.data.negative_sold;
          this.PositiveSold = response.data.positive_sold;
          this.totalSold = response.data.total;
        },
        (error) => {
          this.loading = false;
        }
      );
    },
    searshParent: _.debounce(function () {
      if (this.params.q.toString().length > 1 || !this.params.q.toString().length) {
        this.params.hasfilter = true;
        this.ListPayments();
      }
    }, 200),
  },
};
</script>
